import React, { useState } from "react";
import "./TopReports.scss";
import Header from "../Home/Header/Header";
import ProducttionSale from "./ProducttionSale";
import Customer from "./Customer";
import ProducBy from "./ProducBy";
import Suppliers from "./Suppliers";

const TopReports = () => {

  const [activeTab, setActiveTab] = useState("Product Sale");
  const handleTabClick = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <Header otherPage={true} title="Top Reports" />
      <div style={{ padding: "5px" }}>
        <div className="top-reports-tabs">
          {["Product Sale", "Product Buy", "Customer", "Supplier"].map(
            (tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active-tab" : ""}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            )
          )}
        </div>

        {activeTab === "Product Sale" && <ProducttionSale />}
        {activeTab === "Product Buy" && <ProducBy />}
        {activeTab === "Customer" && <Customer />}
        {activeTab === "Supplier" && <Suppliers />}
      </div>
    </div>
  );
};

export default TopReports;
